import { createContext } from 'react';
import { UploadContextValue } from './interface';

export const UploadContext = createContext<UploadContextValue>({
  open: () => {},
  isDragging: false,
  getDraggerProps: () => ({}),
});
